import { z } from 'zod';
import { useMinLengthString } from './useMinLengthString';
import { useRequiredBoolean } from './useRequiredBoolean';
import { useRequiredEmail } from './useRequiredEmail';
import { useRequiredString } from './useRequiredString';
import { useOptionalString } from './useString';

export function useTranslatedUserSchemaParts() {
    const requiredString = useRequiredString();
    const optionalString = useOptionalString();
    const requiredEmail = useRequiredEmail();
    const requiredBoolean = useRequiredBoolean();
    const minLengthString = useMinLengthString();

    const bad_email_format = 'errors.format.email';
    const address_required = 'checkout.form-error.address-required';
    const first_name_required = 'checkout.form-error.first-name-required';
    const last_name_required = 'checkout.form-error.last-name-required';
    const city_required = 'checkout.form-error.city-required';
    const email_required = 'checkout.form-error.email-required';
    const country_code_required = 'checkout.form-error.country-required';
    const terms_and_conditions_required = 'checkout.form-error.terms-and-conditions-required';
    const mobile_required = 'errors.required.mobile';
    const mobile_min_length = 'errors.min.mobile';
    const password_required = 'errors.required.password';
    const password_min_length = 'errors.min.password';
    const required_locale = 'errors.required.locale';

    return {
        date_of_birth: optionalString().or(z.literal('')),
        optional_date_of_birth: optionalString().or(z.literal('')),
        country_code: requiredString(country_code_required, 8),
        optional_country_code: optionalString(8),
        first_name: requiredString(first_name_required, 64),
        middle_name: optionalString(128),
        last_name: requiredString(last_name_required, 128),
        co: optionalString(128),
        address: requiredString(address_required, 128),
        optional_address: optionalString(128),
        postal_code: optionalString(16).or(z.literal('')),
        optional_postal_code: optionalString(16),
        city: requiredString(city_required, 128),
        optional_city: optionalString(128),
        email: requiredEmail(email_required, bad_email_format, 128),
        phone_number: optionalString(64),
        locale: requiredString(required_locale, 16),
        optional_locale: optionalString(16),
        mobile: minLengthString(mobile_required, mobile_min_length, 8, 64),
        optional_mobile: minLengthString(mobile_required, mobile_min_length, 8, 64).or(z.literal('')),
        terms_and_conditions: requiredBoolean(terms_and_conditions_required),
        password: minLengthString(password_required, password_min_length, 8, 64),
        tags: z.array(z.object({ sql_id: z.number(), name: z.string() })),
        newsletter: z.boolean().nullish(),
        communication_consultant: z.boolean().nullish(),
        vip: z.boolean().nullish(),
        class_interest: z.boolean().nullish(),
        career_interest: z.boolean().nullish(),
    };
}
